import { Pipe, PipeTransform } from '@angular/core';
import { SalesintelFieldMap } from '../../dto/different-interfaces';

@Pipe({
    name: 'salesintelPrettyField',
    standalone: false
})
export class SalesintelPrettyFieldPipe implements PipeTransform {
  transform(value: any, args?: any): any {
    if (typeof SalesintelFieldMap[value] === 'undefined') {
        return value;
    }

    return SalesintelFieldMap[value];
  }
}
